const rankingItems = [
  { rank: 1, title: '某顶流明星被爆私下猛料', hot: '🔥 980万热度', tag: '娱乐圈', trend: 'up' },
  { rank: 2, title: '知名网红直播间翻车现场', hot: '🔥 860万热度', tag: '网红圈', trend: 'up' },
  { rank: 3, title: '热播剧主演被曝隐性恋情', hot: '🔥 740万热度', tag: '娱乐圈', trend: 'new' },
  { rank: 4, title: '综艺节目录制现场内幕曝光', hot: '🔥 620万热度', tag: '综艺', trend: 'up' },
  { rank: 5, title: '某品牌代言人私生活爆料', hot: '🔥 510万热度', tag: '商业圈', trend: 'hot' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          爆料热度榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          全网最热51吃瓜爆料实时排行
        </p>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>
              <span className="inline-flex items-center px-2 py-1 rounded-md bg-background-200 text-xs text-foreground-600 whitespace-nowrap flex-shrink-0">
                {item.tag}
              </span>
              <span className="text-xs text-primary-500 font-medium whitespace-nowrap flex-shrink-0 hidden sm:inline">
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}